/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/mdi-v6/mdi-v6.css'



import '@quasar/extras/animate/slideInRight.css'

import '@quasar/extras/animate/slideOutLeft.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.styl'




import 'src/css/app.styl'

import '@quasar/quasar-ui-qmarkdown/src/index.sass'


import Vue from 'vue'
import createApp from './app.js'


import 'app/src-pwa/register-service-worker.js'




import qboot_Bootbarcolor from 'boot/bar-color'

import qboot_Bootnotify from 'boot/notify'

import qboot_Bootaxios from 'boot/axios'

import qboot_Bootcheckappisactive from 'boot/check-app-is-active'

import qboot_Bootfilters from 'boot/filters'

import qboot_Bootcomponents from 'boot/components'

import qboot_Bootauth from 'boot/auth'

import qboot_Bootsentry from 'boot/sentry'

import qboot_Bootgtag from 'boot/gtag'

import qboot_Bootpwa from 'boot/pwa'

import qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs from '@quasar/quasar-app-extension-qmarkdown/src/boot/register.js'

import qboot_Quasarappextensionqsselectsrcbootqsselectjs from 'quasar-app-extension-qs-select/src/boot/qs-select.js'



import { addPreFetchHooks } from './client-prefetch.js'









// Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(/* webpackChunkName: "fastclick"  */ '@quasar/fastclick')
}


const publicPath = `/`


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootbarcolor,qboot_Bootnotify,qboot_Bootaxios,qboot_Bootcheckappisactive,qboot_Bootfilters,qboot_Bootcomponents,qboot_Bootauth,qboot_Bootsentry,qboot_Bootgtag,qboot_Bootpwa,qboot_Quasarquasarappextensionqmarkdownsrcbootregisterjs,qboot_Quasarappextensionqsselectsrcbootqsselectjs]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    
    addPreFetchHooks(router, store)
    

    

    
      new Vue(app)
    

    

    

  

}

start()
